import { Box } from "@mui/material";
import { DealerUserRole } from "@/gql/graphql";
import AccessDenied from "@/pages/AccessDenied";
import { pageLayout } from "@/theme/pageLayout";
import type { ReactNode } from "react";
import { useContext } from "react";
import { MeContext } from "@/context/me/MeContext";

type SupportAdminRoleGateProps = {
  children: ReactNode;
};

const accessDenied = (variant: "meForbidden" | "default" = "default") => (
  <Box sx={pageLayout}>
    <AccessDenied variant={variant} />
  </Box>
);

export function SupportAdminRoleGate(props: SupportAdminRoleGateProps) {
  const { children } = props;

  const meContext = useContext(MeContext);
  const me = meContext?.me;

  if (!me) {
    return accessDenied("meForbidden");
  }

  const isSupportOrSalesAdmin =
    me.role === DealerUserRole.SupportAdmin ||
    me.role === DealerUserRole.SalesOrderAdmin;

  if (!isSupportOrSalesAdmin) {
    return accessDenied();
  }

  return children;
}
